var map = {
	"./1.png": 14,
	"./banner.png": 7679,
	"./banner1.png": 4966,
	"./banner2.png": 5173,
	"./banner3.png": 6720,
	"./certificate.png": 3888,
	"./certificate1.png": 2989,
	"./details1.png": 191,
	"./details10.png": 7825,
	"./details11.png": 9636,
	"./details12.png": 6706,
	"./details13.png": 4318,
	"./details14.png": 4309,
	"./details2.png": 8955,
	"./details3.png": 7453,
	"./details4.png": 3710,
	"./details5.png": 882,
	"./details6.png": 5905,
	"./details8.png": 4733,
	"./details9.png": 3216,
	"./footer.png": 9604,
	"./footer1.png": 8588,
	"./icon.png": 9184,
	"./icon1.png": 6338,
	"./icon2.png": 2817,
	"./icon3.png": 6159,
	"./icon4.png": 6803,
	"./icon5.png": 9949,
	"./ipa.png": 6839,
	"./ipa1.png": 4967,
	"./ipa2.png": 1818,
	"./ipa3.png": 6627,
	"./ipa4.png": 3860,
	"./ipa5.png": 1904,
	"./ipa6.png": 1973,
	"./ipa7.png": 2161,
	"./ipa8.png": 1368,
	"./ipa9.png": 9279,
	"./ipa_play.png": 4498,
	"./loginlogo.png": 5573,
	"./logo.png": 1053,
	"./nothing.png": 2514,
	"./pas_email.png": 3110,
	"./pas_phone.png": 7957,
	"./search.png": 4132,
	"./test.png": 9296,
	"./test1.png": 6604,
	"./test2.png": 949,
	"./text.png": 2105,
	"./text1.png": 4262,
	"./text2.png": 2821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;